// extracted by mini-css-extract-plugin
export default {"card":"OverviewStorageSection_card__ssXvs","cardAddress":"OverviewStorageSection_cardAddress__uPgVh","noStorageText":"OverviewStorageSection_noStorageText__TqeLP"};